export default __webpack_public_path__ + "static/success-db9c4e682efea4f5080d3adf26b68c41.svg";